import { FieldArray } from "formik";
import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { useOutletContext } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";

const CourseOption = [
  {
    label: "Tech",
    value: "TECH",
  },
  {
    label: "Non-Tech",
    value: "NON_TECH",
  },
];
const CollegeTearOption = [
  {
    label: "Tier One",
    value: "TIER_ONE",
  },
  {
    label: "Tier Two",
    value: "TIER_TWO",
  },
  {
    label: "Tier Three",
    value: "TIER_THREE",
  },
];

const StudentAcademicAndWorkHistory = () => {
  const [{ formikProps }]: any = useOutletContext();

  const { values, setFieldValue, handleBlur, isSubmitting } = formikProps;
  return (
    <div className="">
      <div className="border-l-[3px] border-primary-dark px-3 py-1 z-10  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
        Academic History
      </div>
      <div className="mt-1">
        <FieldArray
          name="academic_history"
          render={({ push, remove }) => (
            <>
              {values?.academic_history?.map((doc: any, index: any) => {
                return (
                  <div key={index}>
                    <div className="flex justify-end mt-3">
                      <MdDelete
                        color="#F70913"
                        size={30}
                        className="pl-1 cursor-pointer"
                        onClick={() => {
                          showConfirmationDialog({
                            title: "Heads Up",
                            text: "Are you sure want to Delete this Academic History?",
                            icon: "question",
                            showCancelButton: true,
                            next: (result) => {
                              if (result.isConfirmed) {
                                remove(index)
                              }
                            }
                          })
                        }}
                      />
                    </div>
                    <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4 items-center">
                      <div>
                        <div>
                          <ATMTextField
                            name={`academic_history[${index}].collge_school_name`}
                            value={
                              values?.academic_history?.[index]
                                ?.collge_school_name
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `academic_history[${index}].collge_school_name`,
                                e.target.value
                              )
                            }
                            label="College School Name"
                            placeholder="Enter College School Name"
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                      <div>
                        <ATMTextField
                          name={`academic_history[${index}].course_name`}
                          value={values?.academic_history?.[index]?.course_name}
                          onChange={(e) =>
                            setFieldValue(
                              `academic_history[${index}].course_name`,
                              e.target.value
                            )
                          }
                          label="Course Name"
                          placeholder="Enter Course Name"
                          onBlur={handleBlur}
                        />
                      </div>
                      {/* Course Type */}
                      <div className="">
                        <ATMSelectValue
                          name={`academic_history[${index}].course_type`}
                          value={values?.academic_history?.[index]?.course_type}
                          onChange={(newValue) =>
                            setFieldValue(
                              `academic_history[${index}].course_type`,
                              newValue
                            )
                          }
                          onBlur={handleBlur}
                          label="Course Type"
                          placeholder="Select Course Type"
                          options={CourseOption}
                        />
                      </div>
                      {/* Course Tier */}
                      <div className="">
                        <ATMSelectValue
                          name={`academic_history[${index}].collge_school_tier`}
                          value={values?.academic_history?.[index]?.collge_school_tier}
                          onChange={(newValue) =>
                            setFieldValue(
                              `academic_history[${index}].collge_school_tier`,
                              newValue
                            )
                          }
                          onBlur={handleBlur}
                          label="College School Tier"
                          placeholder="Select College School Tier"
                          options={CollegeTearOption}
                        />
                      </div>
                      {/* ATMDATEPICKER */}
                      <div>
                        <ATMDatePicker
                         views ={['year']}
                         format="YYYY"
                          name={`academic_history[${index}].start_year`}
                          value={
                            values?.academic_history?.[index]?.start_year ||
                            null
                          }
                          onChange={(newValue) =>
                            setFieldValue(
                              `academic_history[${index}].start_year`,
                              newValue
                            )
                          }
                          label="Start Year"
                        />
                      </div>
                      <div>
                        <ATMDatePicker
                          views ={['year']}
                          format="YYYY"
                          name={`academic_history[${index}].end_year`}
                          value={
                            values?.academic_history?.[index]?.end_year || null
                          }
                          onChange={(newValue) =>
                            setFieldValue(
                              `academic_history[${index}].end_year`,
                              newValue
                            )
                          }
                          label="End Year"
                        />
                      </div>
                      <div className="mt-6">
                        <ATMCheckbox
                          value={
                            values?.academic_history?.[index]
                              ?.currently_pursuing
                          }
                          name={`academic_history[${index}].currently_pursuing`}
                          extraClasses="font-semibold"
                          checked={
                            values?.academic_history?.[index]
                              ?.currently_pursuing
                          }
                          onChange={(e) =>
                            setFieldValue(
                              `academic_history[${index}].currently_pursuing`,
                              e
                            )
                          }
                          label="Currently Pursuing"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="flex justify-end my-4">
                <p
                  className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                  onClick={() =>
                    push({
                      collge_school_name: "",
                      course_name: "",
                      end_year: "",
                      start_year: "",
                      course_type: "",
                      collge_school_tier: "",
                    })
                  }
                >
                  <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                  Add Academic History
                </p>
              </div>
            </>
          )}
        />
      </div>
      <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
        Work History
      </div>
      <div className="mt-1">
        <FieldArray
          name="work_history"
          render={({ push, remove }) => (
            <>
              {values?.work_history?.map((doc: any, index: any) => {
                return (
                  <div key={index}>
                    <div className="flex justify-end mt-3">
                      <MdDelete
                        color="#F70913"
                        size={30}
                        className="pl-1 cursor-pointer"
                        onClick={() => {
                          showConfirmationDialog({
                            title: "Heads Up",
                            text: "Are you sure want to Delete this Work History?",
                            icon: "question",
                            showCancelButton: true,
                            next: (result) => {
                              if (result.isConfirmed) {
                                remove(index)
                              }
                            }
                          })
                        }}
                      />
                    </div>
                    <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4 items-center">
                      <div>
                        <ATMTextField
                          name={`work_history[${index}].company_name`}
                          value={values?.work_history?.[index]?.company_name}
                          onChange={(e) =>
                            setFieldValue(
                              `work_history[${index}].company_name`,
                              e.target.value
                            )
                          }
                          label="Company Name"
                          placeholder="Enter Company Name"
                          onBlur={handleBlur}
                        />
                      </div>
                      <div>
                        <ATMTextField
                          name={`work_history[${index}].job_title`}
                          value={values?.work_history?.[index]?.job_title}
                          onChange={(e) =>
                            setFieldValue(
                              `work_history[${index}].job_title`,
                              e.target.value
                            )
                          }
                          label="Job Title"
                          placeholder="Enter Job Title"
                          onBlur={handleBlur}
                        />
                      </div>

                      <div>
                        <ATMDatePicker
                          views ={['year']}
                          format="YYYY"
                          name={`work_history[${index}].start_year`}
                          value={
                            values?.work_history?.[index]?.start_year || null
                          }
                          onChange={(newValue) =>
                            setFieldValue(
                              `work_history[${index}].start_year`,
                              newValue
                            )
                          }
                          label="Start Year"
                        />
                      </div>
                      <div>
                        <ATMDatePicker
                          views ={['year']}
                          format="YYYY"
                          name={`work_history[${index}].end_year`}
                          value={
                            values?.work_history?.[index]?.end_year || null
                          }
                          onChange={(newValue) =>
                            setFieldValue(
                              `work_history[${index}].end_year`,
                              newValue
                            )
                          }
                          label="End Year"
                        />
                      </div>
                    </div>
                    <div className="mt-6">
                      <ATMTextArea
                        name={`work_history[${index}].job_description`}
                        value={values?.work_history?.[index]?.job_description}
                        onChange={(e) =>
                          setFieldValue(
                            `work_history[${index}].job_description`,
                            e
                          )
                        }
                        label="Job Description"
                        placeholder="Enter Job Description"
                        onBlur={handleBlur}
                      />
                    </div>

                    <div className="mt-6">
                      <ATMCheckbox
                        name={`work_history[${index}].currently_pursuing`}
                        value={
                          values?.work_history?.[index]?.currently_pursuing
                        }
                        extraClasses="font-semibold"
                        checked={
                          values?.work_history?.[index]?.currently_pursuing
                        }
                        onChange={(e) =>
                          setFieldValue(
                            `work_history[${index}].currently_pursuing`,
                            e
                          )
                        }
                        label="Currently Working"
                      />
                    </div>
                  </div>
                );
              })}
              <div className="flex justify-end my-4">
                <p
                  className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                  onClick={() =>
                    push({
                      company_name: "",
                      job_description: "",
                      job_title: "",
                      end_year: "",
                      start_year: "",
                    })
                  }
                >
                  <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                  Add Work History
                </p>
              </div>
            </>
          )}
        />
      </div>
      <div className="flex justify-end mt-4">
        <ATMLoadingButton
          className="flex justify-end w-[90px] px-8"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StudentAcademicAndWorkHistory;
